module.exports = __webpack_public_path__ + "static/media/pk.53eca9c8.webp";